import { render, staticRenderFns } from "./RepoHeader.vue?vue&type=template&id=32f7cca8"
import script from "./RepoHeader.vue?vue&type=script&lang=ts"
export * from "./RepoHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ZTag: require('/app/components/zeal/ZTag/ZTag.vue').default,ZTagV2: require('/app/components/zealv2/ZTagV2.vue').default,ZTab: require('/app/components/zeal/ZTab/ZTab.vue').default})
